import {
  GET_ALL_FEE_GROUPS,
  GET_ALL_FEE_STRUCTURES,
  GET_ALL_COURSES_FOR_GROUP,
  GET_STUDENT_PAYMENTS,
  SET_FEES_COMMON_PARAM,
  GET_ALL_STUDENTS_FOR_FEE_STRUCTURE,
  GET_STUDENT_DETAIL,
  GET_ADJUST_STUDENT_FEE,
  GET_ALL_ADJUST_STUDENT_FEE,
  GET_REFUNDS_FOR_PAYMENT,
  GET_REFUND_TOTAL_FOR_PAYMENT,
  GET_REFUNDS_FOR_STUDENT,
} from 'actions/admin/fees';

const initialState = {
  feeGroups: [],
  feeStructures: {},
  courseListForFeeGroup: [],
  // Keyed by feeStructId - the backend now returns assigned students scoped to one fee
  // structure line at a time, not the whole school in one call.
  studentListForFeeStructure: {},
  // Keyed by studentId - enrichment fetched via the existing single-student lookup, since the
  // fee-structure assignment DTO only returns bare name fields.
  studentDetailsById: {},
  studentPayments: [],
  adjustStudentFees: {},
  allAdjustStudentFees: [],
  refundsByPayment: {},
  refundTotalByPayment: {},
  refundsByStudent: {},
  // Common params
  feesActiveTab: 0,
  feesSubActiveTab: 0,
};

export default function fees(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_FEE_GROUPS: {
      return { ...state, feeGroups: action.feeGroups };
    }
    case GET_ALL_FEE_STRUCTURES: {
      return { ...state, feeStructures: { ...state.feeStructures, [action.feeGroupId]: action.feeStructures } };
    }
    case GET_ALL_COURSES_FOR_GROUP: {
      return { ...state, courseListForFeeGroup: action?.courseListForFeeGroup };
    }
    case GET_ALL_STUDENTS_FOR_FEE_STRUCTURE: {
      return {
        ...state,
        studentListForFeeStructure: {
          ...state.studentListForFeeStructure,
          [action.feeStructId]: action?.studentListForFeeStructure,
        },
      };
    }
    case GET_STUDENT_DETAIL: {
      return {
        ...state,
        studentDetailsById: { ...state.studentDetailsById, [action.studentId]: action.studentDetail },
      };
    }
    case GET_STUDENT_PAYMENTS: {
      return { ...state, studentPayments: action?.studentPayments };
    }
    case GET_ADJUST_STUDENT_FEE: {
      return {
        ...state,
        adjustStudentFees: { ...state.adjustStudentFees, [action.studentId]: action.adjustStudentFeeList },
      };
    }
    case GET_ALL_ADJUST_STUDENT_FEE: {
      return { ...state, allAdjustStudentFees: action?.allAdjustStudentFeeList };
    }
    case GET_REFUNDS_FOR_PAYMENT: {
      return { ...state, refundsByPayment: { ...state.refundsByPayment, [action.studPaymentId]: action.refunds } };
    }
    case GET_REFUND_TOTAL_FOR_PAYMENT: {
      return {
        ...state,
        refundTotalByPayment: { ...state.refundTotalByPayment, [action.studPaymentId]: action.total },
      };
    }
    case GET_REFUNDS_FOR_STUDENT: {
      return { ...state, refundsByStudent: { ...state.refundsByStudent, [action.studentId]: action.refunds } };
    }
    case SET_FEES_COMMON_PARAM: {
      return { ...state, [action.paramName]: action.value };
    }
    default:
      return state;
  }
}
